import { Phone, Mail, MapPin } from "lucide-react";

const practiceLinks = [
  "Criminal Law", "Civil Law", "Family Law", "Property / Real Estate Law",
  "Corporate / Business Law", "Labour Law", "Banking & Finance Law",
  "Constitutional Law", "Intellectual Property Rights",
];

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#081226] text-[#8892ad] relative overflow-hidden">
      {/* Gold line at top */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#b89968]/40 to-transparent" />

      {/* Logo hero anchor */}
      <div className="flex justify-center pt-16 pb-6">
        <img
          src="./images/logo-trimmed.png"
          alt="Corpus Juris Law Chambers"
          className="h-28 md:h-32 w-auto brightness-0 invert opacity-95 drop-shadow-[0_0_22px_rgba(184,153,104,0.25)]"
          data-testid="footer-logo"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-14">
          {/* Practice Areas */}
          <div>
            <h4 className="text-xs font-bold text-white mb-6 tracking-[0.15em] uppercase">Practice Areas</h4>
            <ul className="space-y-2.5">
              {practiceLinks.map((link) => (
                <li key={link}>
                  <button onClick={() => scrollTo("#practice")} className="text-sm text-[#8892ad] hover:text-[#b89968] transition-colors">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold text-white mb-6 tracking-[0.15em] uppercase">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { label: "Home", id: "#home" },
                { label: "About", id: "#about" },
                { label: "Practice Areas", id: "#practice" },
                { label: "Approach", id: "#approach" },
                { label: "Testimonials", id: "#testimonials" },
                { label: "Contact Us", id: "#contact" },
                { label: "Location", id: "#location" },
              ].map((item) => (
                <li key={item.label}>
                  <button onClick={() => scrollTo(item.id)} className="text-sm text-[#8892ad] hover:text-[#b89968] transition-colors">
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold text-white mb-6 tracking-[0.15em] uppercase">Contact</h4>
            <div className="space-y-4">
              <a href="tel:9633717034" className="flex items-center gap-3 text-sm text-[#8892ad] hover:text-[#b89968] transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" />+91 963 3717 034
              </a>
              <a href="mailto:corpusjurieslawchambers@gmail.com" className="flex items-center gap-3 text-sm text-[#8892ad] hover:text-[#b89968] transition-colors break-all">
                <Mail className="w-4 h-4 flex-shrink-0" />corpusjurieslawchambers@gmail.com
              </a>
              <div className="flex items-start gap-3 text-sm text-[#8892ad]">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>Ovungal Bazar, Chavakkad,<br />Thrissur, Kerala, India</span>
              </div>
            </div>
            <div className="mt-8">
              <a href="tel:9633717034" data-testid="footer-cta" className="glossy-btn inline-flex items-center gap-2 px-7 py-3 bg-[#b89968] text-[#081226] text-sm font-bold rounded-full hover:bg-[#e0c29a] transition-all hover:shadow-lg hover:shadow-[#b89968]/30 tracking-wide">
                <Phone className="w-4 h-4" />Call Now
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#142544] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#4a5678]">&copy; {new Date().getFullYear()} Corpus Juris Law Chambers. All rights reserved.</p>
          <p className="text-xs text-[#4a5678]">Adv. Akshay Dominic V &mdash; BBA LLB (Hons)</p>
        </div>
      </div>
    </footer>
  );
}
